import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { NeftStatementComponent } from '../../_modals/neft-statement/neft-statement.component';
import { AuthenticationService } from '../../_services';

@Component({
  selector: 'neft-credit-display',
  templateUrl: './neft-credit-display.component.html' 
})
export class NeftCreditDisplayComponent implements OnInit, OnDestroy {

  neft_obj:any = {};
  authSubscription;
  constructor(
    private modalController: ModalController,
    private authenticationService: AuthenticationService
  ) { 
  }

  ngOnInit() {
    this.init()
  }

  init() {
    this.authSubscription = this.authenticationService.currentUser.subscribe(x => {
      if (x) {
        this.neft_obj = {
          showBalance: x.isNEFT,
          balance: x.balance_NEFT
        }  
      } else {
        this.neft_obj = {}
      }
    });
  }


  async showNeftStatementModel() {
    const modal = await this.modalController.create({
      component: NeftStatementComponent,
      componentProps: {
        balance: this.neft_obj.balance        
      },
      cssClass:['neftStatementContainer']
    });
    return await modal.present();
  }

  ngOnDestroy() {
    this.authSubscription.unsubscribe();
  }


}
